// Squad prediction and check-in rows, as the embed's game sheet reads them. "Submitted" is
// driven only by the server's hidden flag; ranks and winners come from the server too.

export function predictedScoreLabel(row) {
  if (!row || row.home_score == null || row.away_score == null) return '';
  const home = Number(row.home_score);
  const away = Number(row.away_score);
  if (!Number.isFinite(home) || !Number.isFinite(away)) return '';
  return `${home}–${away}`;
}

export function predictionRowName(row) {
  if (row && row.is_you) return 'You';
  const name = String((row && (row.display_name || row.displayName || row.name)) || '').trim();
  return name || 'User';
}

export function hasSquad(data) {
  return !!(data && data.squad);
}

export function squadSwitcherVisible(data) {
  return !!(data && Array.isArray(data.squads) && data.squads.length > 1);
}

export function squadPredictionRows(data) {
  if (!hasSquad(data)) return [];
  const rows = data.predictions && data.predictions.rows;
  return Array.isArray(rows) ? rows : [];
}

export function squadCheckInRows(data) {
  if (!hasSquad(data)) return [];
  const rows = data.check_ins && data.check_ins.rows;
  return Array.isArray(rows) ? rows : [];
}

// Those who acted first, in the server's order, then the rest of the roster.
export function squadRosterRows(data, rows) {
  const acted = Array.isArray(rows) ? rows : [];
  const members = data && Array.isArray(data.members) ? data.members : [];
  const seen = {};
  acted.forEach((row) => {
    seen[String(row.user_id)] = true;
  });
  return acted.concat(members.filter((member) => !seen[String(member.user_id)]));
}

export function scoreOrZero(row) {
  return predictedScoreLabel(row) || '0–0';
}

export function predictionCell(row) {
  if (row && row.hidden) return 'Submitted';
  return scoreOrZero(row).replace('–', ' – ');
}

export function predictedCountLabel(count, total) {
  const n = Number(count) || 0;
  const t = Number(total) || 0;
  return t ? `${n} of ${t} predicted` : `${n} predicted`;
}

export function checkedInCountLabel(count, total) {
  const n = Number(count) || 0;
  const t = Number(total) || 0;
  return t ? `${n} of ${t} checked in` : `${n} checked in`;
}

export function squadPredictionsMode(data, final, switcher) {
  if (!hasSquad(data)) return 'hidden';
  if (squadPredictionRows(data).length > 0) return final ? 'ranked' : 'rows';
  return switcher ? 'empty' : 'hidden';
}

// A ranked list with your own row pulled out under a divider when you sit below the medals.
export function splitPinnedYou(rows) {
  const you = rows.find((row) => row.is_you);
  if (!you || !(Number(you.rank) > 3)) return { rows, pinned: null };
  return { rows: rows.filter((row) => row !== you), pinned: you };
}
